"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.expDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var expDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createExp: _factoriesAny.createExp
};
exports.expDependencies = expDependencies;